import { Index, onMount, Show } from 'solid-js'
import { HourglassIcon } from '~/components/icons/hourglass'

/** A digit that plays its entrance each time it changes after mounting. */
function CountdownDigit(props: { digit: string }) {
  let mounted = false
  onMount(() => (mounted = true))
  return (
    // Keyed: a new digit is a new element, which restarts the animation.
    <Show when={props.digit} keyed>
      {(digit) => (
        <span class={mounted ? 'countdown-digit-enter' : undefined}>
          {digit}
        </span>
      )}
    </Show>
  )
}

/** The design draws the separator as two dots; the text keeps its colon. */
function CountdownSeparator() {
  return (
    <span class="flex h-5 w-[9px] items-center justify-center">
      <span class="sr-only">{' : '}</span>
      <svg
        width="2"
        height="7"
        viewBox="0 0 2 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <circle cx="1" cy="1" r="1" fill="white" fill-opacity="0.7" />
        <circle cx="1" cy="6" r="1" fill="white" fill-opacity="0.7" />
      </svg>
    </span>
  )
}

/** The expiry countdown (GLOSSARY.md), `time` as `HH : MM : SS`. */
export function Countdown(props: { time: string }) {
  return (
    <p
      role="timer"
      class="flex items-center gap-0.5 text-sm font-semibold tabular-nums text-white/70"
    >
      <HourglassIcon />
      <span class="flex items-center">
        <Index each={props.time.split(' : ')}>
          {(group, index) => (
            <>
              <Show when={index > 0}>
                <CountdownSeparator />
              </Show>
              <Index each={group().split('')}>
                {(digit) => <CountdownDigit digit={digit()} />}
              </Index>
            </>
          )}
        </Index>
      </span>
    </p>
  )
}
